import FieldObject from './FieldObject.js'
import people from '../../people'

export default
class HoldersField extends FieldObject {
  getCode (model) {
    return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null
  }
  setCode (model, newCode, onChange) {
    const companyRefCode = newCode
    if (companyRefCode) {
      people.getHolderPassports(companyRefCode).then((holders) => {
        this.setValue(model, companyRefCode, holders, onChange)
        this.cxt.updateItems(model)
      })
    } else {
      this.setValue(model, null, null, onChange)
      this.cxt.updateItems(model)
    }
  }
  setValue (model, newCode, newObject, onChange) {
    if (!this.equalCode(model, newCode)) {
      onChange && onChange(model, this.name, newCode)
      model[this.name + '_CODE'] = newCode ? newCode + '' : null
    }
    model[this.name] = newCode ? JSON.stringify(newObject) : null
  }
  getValue (model) {
    return model[this.name] ? JSON.parse(model[this.name]) : []
  }
  getDescription (model) {
    let obj = model[this.name] ? JSON.parse(model[this.name]) : null
    if (!obj) {
      return ''
    }
    return Array.isArray(obj) ? `Список участников (${obj.length})` : ``
  }
  getHint (model) {
    let obj = model[this.name] ? JSON.parse(model[this.name]) : null
    if (!obj) {
      return ''
    }
    return Array.isArray(obj) ? obj.map(v => v.name).join(', ') : ''
  }
  open (model, onChange) {
    const companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name)
    let items = this.getValue(model)
    Promise.resolve(items)
    .then((items) => new Promise((resolve, reject) => {
      if (!items || items.length === 0) {
        people.getHolderPassports(companyRefCode).then((data) => {
          people.openHolders(companyRefCode, data).then((holders) => {
            resolve(holders)
          })
        })
      } else {
        people.openHolders(companyRefCode, items).then((holders) => {
          resolve(holders)
        })
      }
    }))
    .then((items) => {
      this.setValue(model, companyRefCode, items, onChange)
      // console.log('open', this.getValue(model))
      this.cxt.updateItems(model)
    })
  }
  select (model, onChange) {
    this.open(model, onChange)
  }
}



// WEBPACK FOOTER //
// ./src/components/assist/fields/HoldersField.js